import { PortfolioEventTypeEnum } from "web_myplann/Infrastructure/Api/Api";
import { Routing } from "web_myplann/Infrastructure/Routing/Routing";
import type { EventSourceEnum } from "web_myplann/NotificationCenter/EventAlert/types";
import {
	EVENT_DATE_PARAM,
	EVENT_SOURCE_PARAM,
	EVENT_TYPE_PARAM,
} from "web_myplann/NotificationCenter/Utils/contractEventParams";

type BuildContractEventRouteArgs = {
	portfolioId: string;
	eventSource: EventSourceEnum;
	eventType?: string | null;
	eventDate?: string | null;
};

const EVENT_TYPES: ReadonlySet<string> = new Set(
	Object.values(PortfolioEventTypeEnum),
);

export const buildContractEventRoute = ({
	portfolioId,
	eventSource,
	eventType,
	eventDate,
}: BuildContractEventRouteArgs): string => {
	const basePath = Routing.Portfolio.PortfolioDetail.path(portfolioId);

	const params = new URLSearchParams({ [EVENT_SOURCE_PARAM]: eventSource });
	if (eventType && EVENT_TYPES.has(eventType)) {
		params.set(EVENT_TYPE_PARAM, eventType);
	}
	if (eventDate) {
		params.set(EVENT_DATE_PARAM, eventDate);
	}

	const separator = basePath.includes("?") ? "&" : "?";
	return `${basePath}${separator}${params.toString()}`;
};
